import { toast } from "react-toastify";

/** Suppress identical toasts within this window (ms) */
const DEDUPE_MS = 3500;
const recentToasts = new Map();

const shouldSkip = (type, message) => {
  const text = String(message || "").trim();
  if (!text) return true;
  const key = `${type}:${text}`;
  const now = Date.now();
  const last = recentToasts.get(key);
  if (last && now - last < DEDUPE_MS) {
    return true;
  }
  recentToasts.set(key, now);
  // Prevent unbounded growth
  if (recentToasts.size > 50) {
    for (const [k, t] of recentToasts) {
      if (now - t > DEDUPE_MS) recentToasts.delete(k);
    }
  }
  return false;
};

export const showSuccess = (message) => {
  if (shouldSkip("success", message)) return;
  const toastId = `success:${String(message).trim()}`;
  toast.success(message, { toastId });
};

export const showError = (message) => {
  const text = String(message || "").trim() || "Request failed";
  if (shouldSkip("error", text)) return;
  const toastId = `error:${text}`;
  toast.error(text, { toastId });
};
